import { SET_ENABLED_EDITION } from '../actionTypes';
import { actions } from '../reducer';

export default (value) => actions[SET_ENABLED_EDITION](value);
